import { Text, Tooltip } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { SellerOperator, SellerRestriction } from 'typings'
import { SummaryRow, Tag, TagsListTruncate } from 'ui'
import { messages } from '../messages'

const CONTENT_MAX_WIDTH = 336
const LIST_THRESHOLD = 10

type FilledBlockProps = {
  sellers: SellerRestriction
}

function FilledBlock(props: FilledBlockProps) {
  const {
    sellers: { items },
  } = props
  const { $t } = useIntl()

  if (items.length > LIST_THRESHOLD) {
    return (
      <Tooltip text={$t(messages.sellers.ellipsisTooltip)}>
        <Tag>{items.length}</Tag>
      </Tooltip>
    )
  }

  return (
    <TagsListTruncate
      maxWidth={CONTENT_MAX_WIDTH}
      content={items.map(({ name, id }) => name || id) ?? []}
    >
      {items.map(({ name, id }, index) => (
        <TagsListTruncate.Atom key={index}>
          <Tag>{name || id}</Tag>
        </TagsListTruncate.Atom>
      ))}
    </TagsListTruncate>
  )
}

type EmptyBlockProps = {
  operator: SellerOperator | undefined
}

function EmptyBlock(props: EmptyBlockProps) {
  const { operator } = props
  return operator === SellerOperator.OPTIN ? (
    <FormattedMessage {...messages.sellers.emptyOptIn} />
  ) : (
    <FormattedMessage {...messages.sellers.empty} />
  )
}

type Props = {
  sellers: SellerRestriction | undefined
}

export function SellersRow(props: Props) {
  const { sellers } = props
  const emptySellers = !sellers?.items?.length

  return (
    <SummaryRow>
      <SummaryRow.Title>
        <FormattedMessage
          {...messages.sellers.title}
          values={{
            operator: sellers?.operator,
            b: (content) => (content.length ? <Text>{content}</Text> : null),
          }}
        />
      </SummaryRow.Title>
      <SummaryRow.Value>
        {emptySellers ? (
          <EmptyBlock operator={sellers?.operator} />
        ) : (
          <FilledBlock sellers={sellers} />
        )}
      </SummaryRow.Value>
    </SummaryRow>
  )
}
